var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.814 13.18 1.162 1.628c.814-.814 2.668-2.592 3.575-3.197 1.134-.755 3.488-1.045 5.523.379 1.627 1.138 2.073 3.128 2.092 3.98H22.54v1.337h8.456c.03-.881-.107-2.714-.261-3.255-.698-2.44-2.587-4.853-6.569-4.97-3.185-.092-6.229 2.694-7.352 4.098z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.167 21.55c2.534.116 4.097-1.85 4.562-2.848h2.005c.087.262-.343 1.302-2.761 3.371-3.023 2.587-7.353 1.163-9.446-.668-1.515-1.327-5.667-7.673-6.713-9.097-1.046-1.424-3.633-2.121-5.9-1.046-2.266 1.075-4.04 3.72-2.906 6.743 1.133 3.022 3.661 3.72 5.87 3.545 1.767-.14 4.088-2.538 4.97-3.836l1.307 1.57c-.058.232-.64 1.057-2.5 2.499-2.324 1.801-5.056 1.86-5.637 1.685-.581-.174-3.604-1.104-5.144-3.894s-.727-5.638 0-6.859c.726-1.22 3.836-4.62 7.876-3.487 4.04 1.133 5.405 4.824 7.469 7.469 2.064 2.644 3.779 4.708 6.947 4.853z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAe);
export default __webpack_public_path__ + "static/media/AE.d030680a545f4f7b56867511928e38fc.svg";
export { ForwardRef as ReactComponent };